module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.a28cbcc9.png";